import { render, staticRenderFns } from "./ChangeTheme.vue?vue&type=template&id=da95b802&scoped=true&"
import script from "./ChangeTheme.js?vue&type=script&lang=js&"
export * from "./ChangeTheme.js?vue&type=script&lang=js&"
import style0 from "./ChangeTheme.scss?vue&type=style&index=0&id=da95b802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da95b802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
